export default __webpack_public_path__ + "static/media/html.bfe202ac.svg";